import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=69036cc8&scoped=true"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"
import style0 from "./PublicLayout.vue?vue&type=style&index=0&id=69036cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69036cc8",
  null
  
)

export default component.exports